<div
  class="qr-chip subheading-01-semi-bold"
  [ngClass]="config.hierarchy"
  [style.height.px]="config.size"
>
  <div class="icon-container" *ngIf="config.icon">
    <qr-icon
      class="icon"
      [name]="config.icon"
      [color]="this.iconColor"
    ></qr-icon>
  </div>
  {{ value }}
  <qr-button
    *ngIf="config.isCleanButtonVisible"
    [config]="buttonClear"
    class="button-clear"
    (click)="clear()"
  ></qr-button>
</div>
